import { lazy } from 'react';
import { Routes, SyncHook } from '../routeTypes';

// Lazy load the AvonPatientEmbed component
const AvonPatientEmbed = lazy(() =>
  import('react-components/member-profile/AvonPatientEmbed').then(module => ({
    default: module.AvonPatientEmbed,
  }))
);

export const MEMBER_LIST_PREFIX_PATH = '/member-list';

const useSyncHook: SyncHook = null;

const routes: Routes = [
  {
    path: '/avon-patient',
    element: <AvonPatientEmbed />,
  },
];

const useNavigationHooks = () => {
  return {};
};

export const avonPatientRouteConfig = {
  routes,
  useSyncHook,
  hideNavigationHeader: true,
  useNavigationHooks,
};
